<template>
  <!-- lxl-2024.06.19-布局 -->
  <!-- <div class="base-search-wrapper" :class="{ shodow: !pure }"> -->
    
 <div>
    <!-- 添加任务按钮 -->
    <div class="flex-center" >
        <!-- <slot name="btnGroup">
        </slot> -->
    </div>
   <div class="base-search-wrapper" :class="{ shodow: !pure }">
     <!-- <slot></slot> -->
      <slot name="btnGroup"></slot>
      <slot></slot>
        <!-- <div class="btn-group" :class="{ 'no-search-action': !isSearch, 'is-line': isLine }"> -->
     <div>
      <!-- lxl-2024.06.19-布局 -->
      <div class="search-btn flex-center">
        <template v-if="isSearch">
          <slot name="showMore"></slot>
          <!-- <el-button type="primary" style="margin-top: 15px; border:solid; color:rgb(235 239 244);background: linear-gradient(to right, #6fa3fe, #4cdafe); " plain @click="handleSearch" size="small" v-log="{ page: $route.name, page_event: 'c_search'  }" v-if="isLog">
            {{ $t('global.query') }}
          </el-button> -->
          <button
            plain
            class="btn" 
            @click="handleSearch"
            
            v-if="isLog"  
            >
            <img :src="require('@/images/search.jpg')" class="btn-icon" />
            {{ $t('global.query') }}
          </button>
          <el-button type="primary" style="border: double;color: red;" plain @click="handleSearch" size="small" v-else> {{ $t('global.query') }}</el-button>

          <!-- 隐藏重置按钮 -->
          <el-button size="small" @click="handleReset" v-if="isReset" style="display: none"> {{ $t('formrulestips.reset') }}</el-button>

        </template>
      </div>
     </div>
      
    </div>
    
      <div class="flex-center detail-btn-download" style="float: right;margin-top: -55px;">
        <slot name="btnGroupDetail"></slot>
      </div>
 </div>
 
</template>

<script>
export default {
  name: 'BaseSearch',
  props: {
    isLog: {
      type: Boolean,
      default: true
    },
    isSearch: {
      type: Boolean,
      default: true
    },
    isReset: {
      type: Boolean,
      default: true
    },
    isLine: {
      type: Boolean,
      default: false
    },
    pure: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    /**
     * @description: 点击搜索按钮触发search事件
     */
    handleSearch() {
      this.$emit('search')
    },
    handleReset() {
      this.$emit('reset')
    }
  }
}
</script>

<style lang="scss" scoped>
.base-search-wrapper {
  display: flex;
  flex-wrap: wrap;

  //lxl-布局
  justify-content:flex-start;
  align-items: center;
  //lxl-布局
  
  padding: 15px 5px;
  &.shodow {
    // border-radius: 8px;
    // background-color: #fff;
  }

  .btn-group {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    flex-grow: 1;
    margin-left: 12px;
    height: 52px;
    &.no-search-action {
      height: 32px;
    }

    .search-btn {
      margin-right: 12px;
    }

    .flex-center {
      display: flex;
      align-items: center;
    }
  }
  .is-line {
    width: 100%;
  }
}
.btn {
  background: #5793FA;
  // width: 95px; 
  width: 120px;
  height: 30px; 
  border-radius: 6px; 
  margin-top: 12px; 
  margin-left: 15px; 
  color: #fff; 
  font-size: 15px; 
  cursor: pointer; 
  text-align: center;
  border: none;
  font-family: Microsoft YaHei UI;
  font-weight: bold;
}
.btn-icon {
  width: 15px;
  height: 15px;
  vertical-align: middle;
  margin-top: -2px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/baseSearch.vue